import type { PlayerView, RoleCard } from "../protocol";
import { InfoView } from "./InfoView";
import { Sheet } from "./Sheet";

/** Everything this player has been told, newest first. */
export function NotebookSheet({
  open,
  onClose,
  view,
  roles,
}: {
  open: boolean;
  onClose: () => void;
  view: PlayerView;
  roles: Record<string, RoleCard>;
}) {
  const entries = [...view.private.notebook].reverse();
  return (
    <Sheet open={open} onClose={onClose} label="Notebook">
      <div className="row-between">
        <h3>Notebook</h3>
        <button className="icon-btn" onClick={onClose}>
          Close
        </button>
      </div>
      {entries.length === 0 ? (
        <p className="muted">Nothing yet. What the Storyteller tells you at night appears here.</p>
      ) : (
        <div className="stack">
          {entries.map((e) => (
            <div key={e.seq} className="card card-tight">
              <InfoView entry={e} view={view} roles={roles} />
            </div>
          ))}
        </div>
      )}
      <p className="tiny faint">
        If you are drunk or poisoned, some of this may be false. Only you can see your notebook.
      </p>
    </Sheet>
  );
}
